// This schema is used to faciliate section prefilling for the 790
// '790A': ['II', 'III', 'PQ', 'A', 'B', 'C', 'D', 'E/F', 'G', 'H', 'ADD <br/>A', 'ADD <br/>B', 'ADD <br/>B', 'ADD <br/>C'],

export const sectionTitlesV2 = [
  { prefix: "II", name: "Employer Point of Contact" },
  { prefix: "PQ", name: "Preliminary Questions" },
  { prefix: "A", name: "Job Offer Information" },
  { prefix: "B", name: "Minimum Job Qualifications/Requirements" },
  { prefix: "C", name: "Place of Employment Information" },
  { prefix: "D", name: "Housing Information" },
  { prefix: "E/F", name: "Provision of Meals and Transportation" },
  { prefix: "G", name: "Referral and Hiring Instructions" },
  {
    prefix: "ADD A Crops",
    name: "Addendum A - Additional Crops and/or Agricultural Activities",
  },
  {
    prefix: "ADD B Place",
    name: "Addendum B - Additional Place of Employment Information",
  },
  { prefix: "ADD B Housing", name: "Addendum B - Additional Housing Location" },
  {
    prefix: "ADD C Terms",
    name: "Addendum C - Material Terms and Conditions of the Job Offer",
  },
];
export const sectionTitlesV1 = [
  {
    prefix: "ADD B Place",
    name: "Addendum B - Additional Place of Employment Information",
  },
];

export default {
  II: [
    "eta_790_b1_poc_name",
    "eta_790_b2_poc_dba",
    "eta_790_b15_poc_fein",
    "eta_790_b16_poc_naics_description",
    "eta_790_b16_poc_naics",
    "eta_790_b3_poc_last",
    "eta_790_b4_poc_first",
    "eta_790_b5_poc_middle",
    "eta_790_b6_poc_job_title",
    "eta_790_b7_poc_address_1",
    "eta_790_b8_poc_address_2",
    "eta_790_b9_poc_city",
    "eta_790_b10_poc_state_id",
    "eta_790_b11_poc_zip",
    "eta_790_b12_poc_phone",
    "eta_790_b13_poc_phone_ext",
    "eta_790_b14_poc_email",
    "eta_790_b14a_poc_email_addit",
  ],
  PQ: [
    "prelim_2_employer_type",
    "prelim_3_is_contractor",
    "prelim_4_is_emergency",
    "prelim_5_is_livestock",
  ],
  A: [
    "eta_790a_a1_job_title",
    "eta_790a_a2a_workers_needed_total",
    "eta_790a_a2b_workers_needed_h2a",
    "eta_790a_a3_begin_date",
    "eta_790a_a4_end_date",
    "eta_790a_a5_is_247",
    "eta_790a_a6b_hours_sunday",
    "eta_790a_a6c_hours_monday",
    "eta_790a_a6d_hours_tuesday",
    "eta_790a_a6e_hours_wednesday",
    "eta_790a_a6f_hours_thursday",
    "eta_790a_a6g_hours_friday",
    "eta_790a_a6h_hours_saturday",
    "eta_790a_a6a_hours_total",
    "eta_790a_a7a_hourly_schedule_begin",
    "eta_790a_a7b_hourly_schedule_end",
    "eta_790a_a8a_job_duties",
    "eta_790a_a8b_wage_offer",
    "eta_790a_a8c_wage_offer_per",
    "eta_790a_a8d_piece_rate_offer",
    "eta_790a_a8r_piece_rate_info",
    "eta_790a_a10_frequency_of_pay",
    "eta_790a_a10_frequency_of_pay_other",
    "eta_790a_a11_deductions",
  ],
  B: [
    "eta_790a_b1_education_level",
    "eta_790a_b2_experience_months",
    "eta_790a_b3_training_months",
    "eta_790a_b4a_certification_req",
    "eta_790a_b4b_driver_req",
    "eta_790a_b4c_background_req",
    "eta_790a_b4d_drug_screen_req",
    "eta_790a_b4e_lifting_req",
    "eta_790a_b4g_temperature_req",
    "eta_790a_b4h_pushing_req",
    "eta_790a_b4i_walking_req",
    "eta_790a_b4j_bending_req",
    "eta_790a_b4k_rep_motion_req",
    "eta_790a_b4f_lifting_lbs",
    "eta_790a_b5a_is_supervising",
    "eta_790a_b5b_num_supervised",
    "eta_790a_b6_additional_info",
  ],
  C: [
    "eta_790a_c1_work_address",
    "eta_790a_c2_work_city",
    "eta_790a_c3_work_state_id",
    "eta_790a_c4_work_zip",
    "eta_790a_c5_work_county",
    "eta_790a_c5_work_county_id",
    "eta_790a_c6_work_additional_info",
    "eta_790a_c7_is_work_addendum_b_completed",
  ],
  D: [
    "eta_790a_d1_housing_address",
    "eta_790a_d2_housing_city",
    "eta_790a_d3_housing_state_id",
    "eta_790a_d4_housing_zip",
    "eta_790a_d5_housing_county",
    "eta_790a_d5_housing_county_id",
    "eta_790a_d6_housing_type",
    "eta_790a_d6_housing_type_employer",
    "eta_790a_d6_housing_type_rental",
    "eta_790a_d7_housing_total_units",
    "eta_790a_d8_housing_total_occ",
    "eta_790a_d9_housing_standards",
    "eta_790a_d9_housing_standards_local",
    "eta_790a_d9_housing_standards_state",
    "eta_790a_d9_housing_standards_swa",
    "eta_790a_d9_housing_standards_other_state",
    "eta_790a_d9_housing_standards_other",
    "eta_790a_d9_housing_standards_federal",
    "eta_790a_d9_housing_standards_other_text",
    "eta_790a_d10_housing_additional_info",
    "eta_790a_d11_is_housing_addendum_b_completed",
  ],
  "E/F": [
    "eta_790a_e1_meals_info",
    "eta_790a_e2a_will_not_charge",
    "eta_790a_e2b_will_charge",
    "eta_790a_e2c_meal_charge",
    "eta_790a_f1_daily_transport",
    "eta_790a_f2_transport_to_from",
    "eta_790a_f3a_no_less_than",
    "eta_790a_f3b_no_more_than",
  ],
  G: [
    "eta_790a_g1_how_to_apply",
    "eta_790a_g2_apply_phone",
    // 'eta_790a_g3_apply_email',
    // 'eta_790a_g4_apply_url',
    "apply_extensions",
    "apply_email",
    "apply_url",
  ],
  "ADD A Crops": ["eta_790a_addendum_a"],
  "ADD B Place": ["eta_790a_addendum_b_employment"],
  "ADD B Housing": ["eta_790a_addendum_b_housing"],
  "ADD C Terms": ["eta_790a_addendum_c"],
};
